import { App } from 'vue';
import CurrentUserService from '@/services/currentUserService';

export default (app:App): void => {
  app.directive('has', (el, binding) => {
    const userInfo = CurrentUserService.GetUserInfo();
    let hasPermission = false;
    const permission = binding.arg ?? '';
    if (userInfo && userInfo.role) {
      hasPermission = userInfo.role.includes(permission); // 是否在权限数组里面
    }
    if (!hasPermission && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  });
};
